import DDLogs from '@/DDLogs';
import router from '@/router';
import OtsStateApi from '../../api/OtsStateApi';

const state = {
  otsState: null,
  otsLoading: false,
  otsError: null,
};

const getters = {
  isOtsIlCustomer: state => !!state.otsState,
  otsFlowId: state => state.otsState?.flowId || null,
  otsMarket: state => state.otsState?.market || null,
  otsState: state => state.otsState,
  isInOtsFlow: state => {
    const currentPath = router?.currentRoute?.path || '';
    return !!state.otsState && currentPath.includes('/ots/');
  },
};

const actions = {
  async fetchOtsState({ commit, rootState }, { flowId }) {
    try {
      commit('setOtsLoading', true);
      commit('setOtsError', null);
      if (flowId) {
        const response = await OtsStateApi.getOtsStateByFlowId(flowId);
        commit('setOtsState', response.otsState);
        DDLogs.log('fetchOtsState success', response.otsState);
      } else {
        const response = await OtsStateApi.getLatestOtsState();
        commit('setOtsState', response.otsState);
        DDLogs.log('fetchOtsState success', response.otsState);
      }
    } catch (error) {
      DDLogs.log('fetchOtsState error', error);
      commit('setOtsError', error.message || 'Failed to fetch OTS state');
    } finally {
      commit('setOtsLoading', false);
    }
  },

  async updateOtsState({ commit, rootState }, { flowId, otsPhase, pageIndex }) {
    try {
      commit('setOtsLoading', true);
      commit('setOtsError', null);
      const response = await OtsStateApi.updateOtsState(flowId, otsPhase, pageIndex);
      commit('setOtsState', response.otsState);
      DDLogs.log('updateOtsState success', response.otsState);
      return response.otsState;
    } catch (error) {
      DDLogs.log('updateOtsState error', error);
      commit('setOtsError', error.message || 'Failed to update OTS state');
      throw error;
    } finally {
      commit('setOtsLoading', false);
    }
  },
};

const mutations = {
  // OTS State mutations
  setOtsState(state, otsState) {
    state.otsState = otsState;
  },
  setOtsLoading(state, loading) {
    state.otsLoading = loading;
  },
  setOtsError(state, error) {
    state.otsError = error;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
